import { Stack, styled, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import {
  useWeatherForecast,
  useWeatherLocations,
  WeatherForecast,
  WeatherLocation,
} from 'api/weatherLocations/weatherLocations.api'
import classNames from 'classnames'
import { useTimeoutInterval } from 'hooks/utilsHooks/utilsHooks'
import moment from 'moment'
import React, { ReactElement, useState } from 'react'
import WeatherInfo from './components/WeatherInfo'
import styles from './StartPageHeaderContent.module.less'

export const startpageHeaderContentClass = `startpageHeaderContent`

const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down(`md`)]: {
    display: `none`,
  },
}))

function Clock(): ReactElement {
  const [time, setTime] = useState(moment())

  useTimeoutInterval({ interval: 1000, callback: () => setTime(moment()) })

  return (
    <StyledGrid container sx={{ flexGrow: 1 }} size={{ xl: 3, lg: 4, md: 8 }}>
      <Stack direction="column" justifyContent="flex-start" alignItems="flex-end" sx={{ width: '100%' }}>
        <Typography variant="body1" className={styles.StartPageHeaderContent_BoldText} sx={{ whiteSpace: 'nowrap' }}>
          {time.format(`dddd, D MMMM`)}
        </Typography>
        <h3 className={styles.StartPageHeaderContent_Clock} style={{ whiteSpace: 'nowrap', marginTop: 4 }}>
          {time.format(`HH:mm:ss`)}
        </h3>
      </Stack>
    </StyledGrid>
  )
}

// TODO: Weather info is only avaible currently for opt model. Should support digital twin too.
export default function StartpageHeaderContent(): ReactElement {
  const weatherLocationsQueriesReponse = useWeatherLocations()
  const weatherLocations = weatherLocationsQueriesReponse.reduce<WeatherLocation[]>((locations, response) => {
    return response.data ? [...locations, response.data] : locations
  }, [])

  const weatherForecastQueriesResponse = useWeatherForecast({ start_time: moment().add(1, `hour`).set(`minutes`, 0) })
  const weatherForecast: Record<string, WeatherForecast[]> = weatherForecastQueriesResponse.reduce(
    (forecasts, response) => {
      return response.data ? { ...forecasts, ...response.data } : forecasts
    },
    {}
  )

  return (
    <Grid
      container
      sx={{ flexGrow: 1 }}
      direction="row"
      justifyContent="flex-end"
      className={classNames(startpageHeaderContentClass, styles.StartPageHeaderContent_HeaderContent)}
    >
      <Grid
        container
        sx={{ flexGrow: 1 }}
        direction="row"
        justifyContent="flex-end"
        size={{ xl: 8, lg: 7, md: 4, sm: 4, xs: 12 }}
        className={styles.StartPageHeaderContent_WeatherGrid}
      >
        {weatherLocations.length
          ? weatherLocations.map((location) => {
              return (
                <Grid key={location.id}>
                  <WeatherInfo forecast={weatherForecast[location.id]} location={location} />
                </Grid>
              )
            })
          : null}
      </Grid>
      <Clock />
    </Grid>
  )
}
